import * as React from 'react'
const CheckInCircleSVG = ({ fillColor, ...rest }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 22 22'
    width={rest.width}
    height={rest.width}
    fill='none'
    preserveAspectRatio='xMinYMin meet'
    {...rest}
  >
    <path
      fill={rest.fill}
      stroke={rest.fill}
      strokeMiterlimit={10}
      d='M21 11c0-5.52-4.48-10-10-10S1 5.48 1 11s4.48 10 10 10 10-4.48 10-10Z'
    />
    <path fill={rest.fill} d='m16 6.833-7 8.334-3-3.334' />
    <path
      stroke={fillColor}
      strokeLinecap='round'
      strokeLinejoin='round'
      d='m16 6.833-7 8.334-3-3.334'
    />
  </svg>
)
export default CheckInCircleSVG
